import Link from "next/link";

export default function ModeChoice({ readingId, title }: { readingId: string; title: string }) {
  return (
    <div className="rise-in">
      <p className="mb-10 font-body text-lg leading-relaxed text-paper/85">
        Saved <span className="font-semibold text-paper">{title}</span>. How do you want to work through it?
      </p>
      <div className="grid gap-5 md:grid-cols-2">
        <Link
          href={`/reading/${readingId}`}
          className="group flex min-h-56 flex-col justify-between gap-10 rounded-[2rem] bg-blue p-8 text-blue-deep hover:-translate-y-1"
        >
          <span>
            <span className="mb-3 block font-heading text-3xl">Quick read</span>
            <span className="block max-w-sm font-body text-lg leading-relaxed">
              The rebuilt reading only. Watch Syft work through the document, then read it once.
            </span>
          </span>
          <span className="font-body text-base font-semibold">
            Start{" "}
            <span aria-hidden className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </span>
        </Link>
        <Link
          href={`/reading/${readingId}/deep-look`}
          className="group flex min-h-56 flex-col justify-between gap-10 rounded-[2rem] bg-ink-alt p-8 text-paper hover:-translate-y-1 hover:bg-paper/10"
        >
          <span>
            <span className="mb-3 block font-heading text-3xl">Deep read</span>
            <span className="block max-w-sm font-body text-lg leading-relaxed text-paper/85">
              Work through it actively, answering questions as you go.
            </span>
          </span>
          <span className="font-body text-base font-semibold text-blue">
            Start{" "}
            <span aria-hidden className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </span>
        </Link>
      </div>
    </div>
  );
}
